import { render } from "./EditNodeBox.vue?vue&type=template&id=f58ad72c&scoped=true&ts=true"
import script from "./EditNodeBox.vue?vue&type=script&lang=ts"
export * from "./EditNodeBox.vue?vue&type=script&lang=ts"

import "./EditNodeBox.vue?vue&type=style&index=0&id=f58ad72c&scoped=true&lang=css"

import exportComponent from "P:\\roboworks\\easyros\\easyros\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f58ad72c"]])

export default __exports__